import { ApiType } from "@gymflow/common";
import { KisiPlace } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useQueryKisiPlaceList(
  {
    api,
  }: {
    api: ApiType;
  },
  queryOpts?: Omit<UseQueryOptions<KisiPlace[]>, "queryKey">,
) {
  return useQuery({
    queryKey: kisiQueryKeys.places(),
    queryFn: async () => {
      const result = await api.kisiApi.fetchPlaces();
      return result.data;
    },
    ...queryOpts,
  });
}
